import React, { useEffect } from "react";
import MaroonNavbar from "@/components/new/MaroonNavbar";
import MaroonFooter from "@/components/new/MaroonFooter";
import WhatsAppButton from "@/components/new/WhatsAppButton";

const C = { maroon: "#621B21", maroonDark: "#5C0F1C", yellow: "#F5C800", beige: "#F5EDD6" };

const RefundPolicyPage = () => {
  useEffect(() => { document.title = "ETHIA | Refund Policy"; }, []);
  return (
    <div className="min-h-screen" style={{ fontFamily: "Manrope, sans-serif" }} data-testid="refund-policy-page">
      <MaroonNavbar />
      <section className="pt-32 md:pt-40 pb-16 md:pb-24" style={{ background: C.beige }}>
        <div className="max-w-[720px] mx-auto px-5 md:px-8">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-8" style={{ color: C.maroon, fontFamily: "Fraunces, serif" }}>Refund Policy</h1>

          <div className="space-y-8 text-sm leading-relaxed" style={{ color: `${C.maroon}CC` }}>
            <div>
              <h2 className="text-lg font-bold mb-3" style={{ color: C.maroon, fontFamily: "Fraunces, serif" }}>Refund Process</h2>
              <p>Depending on the mode of payment and bank policies, refunds will be credited to your account within <strong style={{ color: C.maroon }}>10 to 14 working days</strong>.</p>
              <p className="mt-3">In case it is taking longer than 10 to 14 working days, please drop an email to <a href="mailto:admin@ethia.in" className="font-bold underline" style={{ color: C.maroon }}>admin@ethia.in</a> and we will fix it as soon as possible.</p>
            </div>

            <div>
              <h2 className="text-lg font-bold mb-3" style={{ color: C.maroon, fontFamily: "Fraunces, serif" }}>Eligibility</h2>
              <p className="mb-3">Since ETHIA products are freshly prepared and perishable, refunds/replacements are applicable only in the following cases:</p>
              <ul className="space-y-2 ml-4">
                <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0" style={{ background: C.yellow }} /><span>Damaged or leaking packaging on delivery</span></li>
                <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0" style={{ background: C.yellow }} /><span>Wrong product delivered</span></li>
                <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0" style={{ background: C.yellow }} /><span>Quality issues (spoilage, foreign matter, etc.)</span></li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-bold mb-3" style={{ color: C.maroon, fontFamily: "Fraunces, serif" }}>How to Report</h2>
              <p>Please report the issue within <strong style={{ color: C.maroon }}>24 hours of delivery</strong>, along with your order ID and photos/videos of the product, to <a href="mailto:admin@ethia.in" className="font-bold underline" style={{ color: C.maroon }}>admin@ethia.in</a> / <a href="tel:+919327927782" className="font-bold underline" style={{ color: C.maroon }}>+91 93279 27782</a>.</p>
              <p className="mt-3">As our products are perishable, we are unable to accept physical returns. Approved cases will be resolved via refund or replacement, at ETHIA's discretion.</p>
            </div>

            <div>
              <h2 className="text-lg font-bold mb-3" style={{ color: C.maroon, fontFamily: "Fraunces, serif" }}>For Subscriptions</h2>
              <p>Subscriptions can be cancelled anytime by writing to <a href="mailto:admin@ethia.in" className="font-bold underline" style={{ color: C.maroon }}>admin@ethia.in</a>. Cancelling before your committed period may affect the discount and free-month benefit already availed under that plan.</p>
            </div>
          </div>
        </div>
      </section>
      <MaroonFooter />
      <WhatsAppButton />
    </div>
  );
};

export default RefundPolicyPage;
